import styledCSS from "../../../../../styles/module/others/iconeSuspended.module.css";

export default function IconeAcessibilidade() {
  return (
    <>
      <div
        className={styledCSS.cardAcessibilidade}
        onClick={() => document.getElementsByClassName("uai")[0].click()}
        style={{top: "279px", padding: "8px"}}
      >
        <img
          style={{ width: "36px", marginRight: "10px" }}
          src="/icons/acessibilidade-white.svg"
          alt="Ícone de Acessibilidade"
        />
        <span>Acessibilidade</span>
      </div>
    </>
  );
}
